export default "__VITE_ASSET__B56O5lJe__"